import './index.css';
import Login from './pages/Login';
import Teacher from './pages/Teacher';
import Student from './pages/Student';
import ReactDOM from 'react-dom/client';
import Class from './pages/Teacher/Class';
import Content from './pages/Teacher/Content';
import Progress from './pages/Teacher/Progress';
import Settings from './pages/Student/Settings';
import Missions from './pages/Student/Missions';
import TaskScreen from './components/TaskScreen';
import Challenges from './pages/Student/Challenges';
import Scoreboard from './pages/Student/Scoreboard';
import Cheatsheet from './pages/Student/Cheatsheet';
import ProtectedRoute from './components/ProtectedRoute';

import { useParams } from 'react-router-dom';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

const ClassWithId = () => {
  const { teacherId, classId } = useParams();
  return <Class classId={classId} teacherId={teacherId} />;
}

const TeacherWithId = () => {
  const { teacherId } = useParams();
  return <Teacher teacherId={teacherId} />
}

const StudentWithId = () => {
  const { studentId } = useParams();
  return <Student studentId={studentId} />;
}

const ProgressWithId = () => {
  const { teacherId, classId } = useParams();
  return <Progress classId={classId} teacherId={teacherId}/>;
}

const SettingsWithId = () => {
  const { studentId } = useParams();
  return <Settings studentId={studentId} />;
}

const MissionsWithId = () => {
  const { studentId } = useParams();
  return <Missions studentId={studentId} />;
}

const MissionWithId = () => {
  const { studentId, missionId } = useParams();
  return <TaskScreen taskType="Mission" taskId={missionId} studentId={studentId} />
}

const ChallengesWithId = () => {
  const { studentId } = useParams();
  return <Challenges studentId={studentId} />
}

const ChallengeWithId = () => {
  const { studentId, challengeId } = useParams();
  return <TaskScreen taskType="Challenge" taskId={challengeId} studentId={studentId} />
}

const ScoreboardWithId = () => {
  const { studentId } = useParams();
  return <Scoreboard studentId={studentId} />
}

const CheatsheetWithId = () => {
  const { studentId } = useParams();
  return <Cheatsheet studentId={studentId} />
}

const ContentWithId = () => {
  const { teacherId } = useParams();
  return <Content teacherId={teacherId} />
}

const router = createBrowserRouter([
  { path: "/", element: <Login /> },
  { path: "/login", element: <Login /> },
  {
    element: <ProtectedRoute />,
    children: [
      { path: "/teacher/:teacherId", element: <TeacherWithId /> },
      { path: "/teacher/:teacherId/class/:classId", element: <ClassWithId /> },
      { path: "/teacher/:teacherId/content", element: <ContentWithId /> },
      { path: "/teacher/:teacherId/progress/:classId", element: <ProgressWithId /> },
      { path: "/student/:studentId", element: <StudentWithId />},
      { path: "/student/:studentId/settings", element: <SettingsWithId />},
      { path: "/student/:studentId/missions", element: <MissionsWithId />},
      { path: "/student/:studentId/mission/:missionId", element: <MissionWithId />},
      { path: "/student/:studentId/challenges", element: <ChallengesWithId />},
      { path: "/student/:studentId/challenge/:challengeId", element: <ChallengeWithId />},
      { path: "/student/:studentId/scoreboard", element: <ScoreboardWithId />},
      { path: "/student/:studentId/cheatsheet", element: <CheatsheetWithId />},
    ],
  },
]);

root.render( <RouterProvider router={router} />);